var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 54,
    viewBox: "0 0 131 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24294 52.748C3.74545 53.2329 1.59897 53.1175 0.121094 52.748H6.24294C11.6317 51.7019 18.6546 47.8611 24.1211 37.748C27.6211 31.4147 38.2211 20.948 52.6211 29.748C57.9544 33.5812 70.4211 39.0263 79.6211 25.4263C83.1211 19.1051 86.1211 14.4263 100.121 18.2475C105.621 19.4263 110.321 16.3518 115.121 4.75176C117.621 0.429199 121.821 -0.648236 130.621 1.75176V52.748H6.24294Z",
    fill: "url(#paint0_linear_131_23833)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.121094 52.748C4.78776 53.9147 16.1211 52.548 24.1211 37.748C27.6211 31.4147 38.2211 20.948 52.6211 29.748C57.9544 33.5812 70.4211 39.0263 79.6211 25.4263C83.1211 19.1051 86.1211 14.4263 100.121 18.2475C105.621 19.4263 110.321 16.3518 115.121 4.75176C117.621 0.429199 121.821 -0.648236 130.621 1.75176",
    stroke: "#273961"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_23833",
    x1: 65.3711,
    y1: 0.499512,
    x2: 65.3711,
    y2: 53.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.1c8ab2a44b85ded32dbe9a323b934ca2.svg";
export { ForwardRef as ReactComponent };